import { jwtDecode } from "jwt-decode";


interface DecodedToken {
    email: string;
    preferredLanguage: string;
    iat: number;
    exp: number;
    iss: string;
    isVerified: boolean;
}

export const isTokenExpired = (): boolean => {
    const decoded = decodeToken();
    if (decoded) {
        const currentTime = Math.floor(Date.now() / 1000);
        return decoded.exp < currentTime;
    }

    return true;
};


export const getAccessToken = (): string | null => {
    return localStorage.getItem('accessToken');
};

export const getDecodedAccessToken = (): any | null => {
    const token = getAccessToken();
    if (!token) return null;
    try {
        const payload = token.split('.')[1];
        return JSON.parse(atob(payload));
    } catch (e) {
        console.error('Failed to decode token', e);
        return null;
    }
};

export const setAccessToken = (token: string) => {
    localStorage.setItem('accessToken', token);
};

export const getRefreshToken = (): string | null => {
    return localStorage.getItem('refreshToken');
};

export const setRefreshToken = (token: string) => {
    localStorage.setItem('refreshToken', token);
};

export const clearAll = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
};

const decodeToken: () => DecodedToken | null = () => {
    try {
        const token = getAccessToken();

        if (!token) {
            return null;
        }

        const decoded = jwtDecode<DecodedToken>(token);
        return decoded;
    } catch {
        return null;
    }
};
